import { datadogLogs } from "@datadog/browser-logs";
import { Storage } from "aws-amplify";

export const PUBLIC_FILE_KEY_PREFIX = "public/";
export const UPLOAD_FILE_KEY_PREFIX = "uploads/";
const getCustomPrefix = (isTemporary?: boolean) => {
  return isTemporary
    ? {
        public: UPLOAD_FILE_KEY_PREFIX,
      }
    : undefined;
};

export const uploadFile: any = async (
  key: string,
  file: File,
  options?: {
    isTemporary?: boolean;
    progressCallback?: (progress: { loaded: number; total: number }) => void;
  },
) => {
  const putResult = await Storage.put(key, file, {
    customPrefix: getCustomPrefix(options?.isTemporary),
    progressCallback: options?.progressCallback,
  });

  const props = await getFileProperties(putResult.key, options?.isTemporary);

  return {
    ...putResult,
    resolved: getCustomPrefix(options?.isTemporary)?.public + putResult.key,
    properties: props,
  };
};

export const getFileProperties: any = async (
  key: string,
  isTemporary?: boolean,
) => {
  const props = await Storage.getProperties(key, {
    customPrefix: getCustomPrefix(isTemporary),
  });

  props.eTag = props.eTag.replace(/"/g, "");
  return props;
};

export const logger = datadogLogs.logger;

export const getStudentDomain = () => {
  return (
    process.env.REACT_APP_STUDENT_APP_URL ?? "https://student.examspark.com"
  );
};
